import { createSelector } from 'reselect'
import getFastTrackExtensionExpirationDate from 'modules/loyalty/redux/selectors/get-fast-track-extension-expiration-date'
import getFastTrackExpireOnNextTierLoyaltySelect from 'modules/loyalty/redux/selectors/get-expire-on-fast-track-next-tier'
import getFastTrackExpireOrExtensionDateLoyaltySelectUtil from 'modules/loyalty/redux/selectors/get-fast-track-expire-or-extension-date/utils'

const getFastTrackExpireOrExtensionDateLoyaltySelect = createSelector(
  getFastTrackExpireOnNextTierLoyaltySelect,
  getFastTrackExtensionExpirationDate,
  /**
   * @param {Date|null} fastTrackExpirationDate
   * @param {Date|null} fastTrackExtensionExpirationDate
   */
  (
    fastTrackExpirationDate,
    fastTrackExtensionExpirationDate
  ) => getFastTrackExpireOrExtensionDateLoyaltySelectUtil({
    fastTrackExpirationDate,
    fastTrackExtensionExpirationDate
  })
)

export default getFastTrackExpireOrExtensionDateLoyaltySelect
